<script lang="ts">
	import SiteSetting from "../../organisms/settings/SiteSetting.svelte";
</script>

<div class="flex">
	<div class="flex-1 mr-8">
		<SiteSetting/>
	</div>
</div>